/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/chain'
export default icon
